import { useLocation, useSearchParams } from 'react-router-dom';
import { useCanEdit } from '@/lib/queries';
import { parseTo, type Audience } from '@/lib/email';
import { adminLinks } from '@/lib/links';
import { ErrorNote } from '@/components/Layout';
import { EmailCompose } from '@/components/EmailCompose';

/** Admins write to a person, household, dojo, all current members, or a filtered members list. */
export function AdminEmailCompose() {
  const canEdit = useCanEdit();
  const location = useLocation();
  const [params] = useSearchParams();
  if (!canEdit) return <ErrorNote>Only admins can send emails. Admin viewers can see what has been sent on the Email tab.</ErrorNote>;
  const given = (location.state as { audience?: Audience } | null)?.audience ?? parseTo(params.get('to'));
  return <EmailCompose mode="admin" given={given} back={{ to: '/admin/email', label: 'Email' }} sentLink={adminLinks.emailBatch} />;
}
